import { useParams } from "react-router";
import { useCredentialsListParams } from "@/features/credentials/pages/list/hooks/use-credentials-list-params";

export function useCredentialEditParams() {
  const listParams = useCredentialsListParams();
  const { credentialId } = useParams();

  if (!credentialId) {
    throw new Error("Missing required route parameter: credentialId");
  }

  return {
    ...listParams,
    credentialId,
  };
}
